import { render, staticRenderFns } from "./ReposrtCardGroupData.vue?vue&type=template&id=4500916b&lang=pug&"
import script from "./ReposrtCardGroupData.vue?vue&type=script&lang=js&"
export * from "./ReposrtCardGroupData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports